import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from './../../reducer';
import { SelectMultiple } from '../../tailwindcomponents';
import { Typography, Paper, Card, Dialog } from '../../tailwindcomponents';
import { CalendarUI, ProfileImg } from "../../components";
import LineWorkpackageCard from "../Line/LineWorkpackageCard";
import crewPlanApi from './../../api/crewPlan';
import { Event } from '../../types/tasks';
import { MxiStaffManagementEmployee } from '../../types/staffManagement';
import { LineWorkPackages } from './../../types/line';
import staffmanagementApi from '../../api/staffmanagement';
import CrewPlanDialog from './CrewPlanDialog';

const statusOptions = [
    { id: 0, name: "ACTV" },
    { id: 1, name: "IN WORK" },
    { id: 2, name: "CANCEL" },
    { id: 3, name: "COMPLETE" },
    { id: 4, name: "PAUSE" },
];

function CrewPlan() {
    const store = useSelector((state: RootState) => state);
    const [pageTitle, setPageTitle] = useState(store.user.me.crew_plan_location);
    const [tasksOnCalendar, setTasksOnCalendar] = useState<Event[]>([]);
    const [tasksbyUser, setTasksByUser] = useState(Array<LineWorkPackages>);
    const [eventDialogOpen, setEventDialogOpen] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState<LineWorkPackages>();
    const [myCrew, setMyCrew] = useState(Array<MxiStaffManagementEmployee>);
    const [selectedOptions, setSelectedOptions] = useState<number[]>([0, 1, 4]);
    const [tasksByUserDialogOpen, setTasksByUserDialogOpen] = useState(false);
    const users = store.employees.all_employees;

    useEffect(() => {
        refresh()
        staffmanagementApi.GetAllMembersFromMyCrew().then(res => {
            if (res.status) {
                setMyCrew(res.data)
            }
        })
    }, [selectedOptions]);

    const refresh = () => {
        const tempSelectedStatus: string[] = [];
        selectedOptions.map(index => {
            tempSelectedStatus.push(statusOptions[index].name)
        });
        crewPlanApi.GetTasksAssignedByMyCrew().then(res => {
            if (res.status === false) {
                setPageTitle(store.user.me.crew_plan_location + "(" + res.message + ")")
            } else {
                let tempTasks: Array<Event> = []
                res.data.forEach(task => {
                    task.start = new Date(task.start)
                    task.end = new Date(task.end)
                    tempTasks.push(task)
                });
                tempTasks = tempTasks.filter(s => tempSelectedStatus.includes(s.task_details.status));
                setPageTitle(store.user.me.crew_plan_location + "(" + tempTasks.length + ")");
                setTasksOnCalendar(tempTasks);
            }
        });
    }

    const onEventClick = (event: Event) => {
        const taskDetails = event.task_details;
        const lineWorkpackage = {
            wo_number: taskDetails.wo_number,
            wo_barcode: taskDetails.wo_barcode,
            task_barcode: taskDetails.barcode,
            status: taskDetails.status,
            title: event.title,
            mxi_start_date_text: event.start_date_text,
            mxi_end_date_text: event.end_date_text,
            mxi_due_date_text: "",
            maintener_planned_date_text: "",
            tail_number: taskDetails.tail_number,
            scheduled_task_id: event.scheduled_task_id,
            is_task_critical: taskDetails.is_task_critical,
            is_on_hold: false,
            is_on_time: false,
            package_duration_text: "",
            aircraft_arrival_and_departure_times: ""
        } as LineWorkPackages;
        setSelectedEvent(lineWorkpackage);
        setEventDialogOpen(true);

    }

    const onDialogClose = () => {
        refresh();
        setEventDialogOpen(false);
    }
    const countHowManyTasksAssigned = (employee_name: string) => {
        let count = 0;
        tasksOnCalendar.map(s => {
            const item = s.task_details.assigned_employees_on_calendar.includes(employee_name);
            if (item) {
                count++;
            }
        })
        return count;
    }
    const onUserClicked = (userId: number) => {
        crewPlanApi.GetTasksAssignedEmployeeId(userId).then(res => {
            if (res.status) {
                const array: Array<LineWorkPackages> = [];
                res.data.map(s => {
                    const taskDetails = s.task_details;
                    const task = {
                        task_barcode: taskDetails.barcode,
                        status: taskDetails.status,
                        task_name: s.title,
                        mxi_start_date_text: s.start_date_text,
                        mxi_end_date_text: s.end_date_text,
                        is_task_critical: taskDetails.is_task_critical,
                        assigned_employees: taskDetails.assigned_employees_on_calendar,
                        wo_name: taskDetails.wo_name,
                    } as LineWorkPackages;
                    array.push(task);
                });
                setTasksByUser(array);
                setTasksByUserDialogOpen(true);
            }
        })
    }


    return (
        <div>
            <Typography text={pageTitle} align='center' variant='h1' color='primary' />
            <div className="flex flex-wrap">
                {myCrew.map((user, index) => (
                    <div className="w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/4 xl:w-1/6">
                        <Paper className="m-[3px]" onClick={() => onUserClicked(user.employee_id)}>
                            <div className="flex flex-wrap w-full items-center">
                                <div className="w-1/12 flex justify-center">
                                    <ProfileImg imgKey={index} imgSize="xs" userName={users?.find(s => s.Id === user.employee_id)?.userName?.split('@')[0]} />
                                </div>
                                <div className="w-3/4"><Typography text={user.employee_full_name} align='center' /></div>
                                <div>{countHowManyTasksAssigned(user.employee_full_name)}</div>
                            </div>
                        </Paper>
                    </div>
                ))}
            </div>
            <div className="flex flex-wrap w-full">
                <div className="w-1/3 justify-start">
                    <SelectMultiple
                        optionsObject={statusOptions}
                        onSelectedItem={(e: any) => setSelectedOptions(e.target.value)}
                        selectedItems={selectedOptions}
                        width={200}
                        filter_by_text={"Filter by status"}
                    />
                </div>
                <div className="w-1/2 justify-center">
                        <span className="inline-block w-4 h-4 mr-[5px] ml-[10px] mt-5 bg-[#53C0E8]"></span><span className="text-lg"> PRE</span>
                        <span className="inline-block w-4 h-4 mr-[5px] ml-[10px] mt-5 bg-[#FFDB0C]"></span><span className="text-lg"> OPEN</span>
                        <span className="inline-block w-4 h-4 mr-[5px] ml-[10px] mt-5 bg-[#001A71]"></span><span className="text-lg"> INSP</span>
                        <span className="inline-block w-4 h-4 mr-[5px] ml-[10px] mt-5 bg-background-paper border border-black"></span><span className="text-lg"> IN WORK</span>
                        <span className="inline-block w-4 h-4 mr-[5px] ml-[10px] mt-5 bg-[#BE03FF]"></span><span className="text-lg"> NON_ROUTINE</span>
                        <span className="inline-block w-4 h-4 mr-[5px] ml-[10px] mt-5 bg-[#FF37BE]"></span><span className="text-lg"> TEST</span>
                        <span className="inline-block w-4 h-4 mr-[5px] ml-[10px] mt-5 bg-[#50E68C]"></span><span className="text-lg"> CLOSE</span>
                        <span className="inline-block w-4 h-4 mr-[5px] ml-[10px] mt-5 bg-[#6495ED]"></span><span className="text-lg"> ADMIN</span>
                </div>
            </div>
            <CalendarUI
                isTaskAssignment={true}
                edit={false}
                totalPlanned={"-1"}
                fullScreen={true}
                setFullScreen={(fullScreen: boolean) => console.log("full screen")}
                clickedTaskDate={undefined}
                tasksOnCalendar={tasksOnCalendar}
                draggedTasks={[]}
                onDropFromOutside={() => { }}
                onEventDrop={() => { }}
                onCheckboxClicked={() => { }}
                onEventClick={(event: Event) => { onEventClick(event); }}
            />
            <Dialog
                visible={tasksByUserDialogOpen}
                max_width={"lg"}
                title={selectedEvent?.title}
                context={
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        {tasksbyUser.map((task, index) => (
                            <div key={index}>
                                <Card>
                                    <LineWorkpackageCard type='BAY-USER' task={task} onOpenDialogClicked={(taskBarcode: string) => { }} />
                                </Card>
                            </div>
                        ))}
                    </div>
                }
                onClose={(status: any) => { setTasksByUserDialogOpen(false); setTasksByUser([]) }}
                strict={false}
                show_options={false}
            />
            <Dialog
                visible={tasksByUserDialogOpen}
                max_width={"lg"}
                title={selectedEvent?.title}
                context={
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        {tasksbyUser.map((task, index) => (
                            <div key={index}>
                                <Card>
                                    <LineWorkpackageCard type='BAY-USER' task={task} onOpenDialogClicked={(taskBarcode: string) => { }} />
                                </Card>
                            </div>
                        ))}
                    </div>
                }
                onClose={(status: any) => { setTasksByUserDialogOpen(false); setTasksByUser([]) }}
                strict={false}
                show_options={false}
            />
            <Dialog
                visible={eventDialogOpen}
                max_width={"lg"}
                title={selectedEvent?.title}
                context={
                    <CrewPlanDialog myCrew={myCrew} selectedEvent={selectedEvent} />
                }
                onClose={(status: any) => { onDialogClose() }}
                strict={false}
                show_options={false}
            />
        </div >
    );
}
export default CrewPlan;